// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.import-from-local {
  position: fixed;
  right: 0px;
  top: 0px;
  width: 138px;
  margin-right: 25px;
  margin-top: 23px;
  min-width: 42px;
  height: 42px;
  opacity: 1;
  border-radius: 25px;
  line-height: 42px;
  text-align: center;
  cursor: pointer;
  z-index: 5;
  font-size: 15px;
  transition: 0.1s;
  font-weight: 500;
}

.import-book-box {
  position: relative;
  bottom: 42px;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  z-index: 10;
  opacity: 0;
  cursor: pointer;
  font-size: 0;
}
.drag-section {
  position: absolute;
  top: 75px;
  width: calc(100% - 200px);
  height: calc(100vh - 90px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
}
.more-import-option {
  position: absolute;
  width: 30px;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 11;
  background-color: rgba(0, 0, 0, 0.1); /* Semi-transparent white overlay */
  border-radius: 0 30px 30px 0;
}

.icon-more {
  font-size: 20px;
}

.more-options-dropdown {
  position: absolute;
  right: 0;
  top: 100%;
  border-radius: 10px;
  width: 200px;
  z-index: 999;
  margin-top: 5px;
  overflow: hidden;
  padding-top: 4px;
  padding-bottom: 4px;
}

.more-option-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 20px;
  transition: 0.2s;
  line-height: 1;
  height: 40px;
  cursor: pointer;
  text-align: left;
}

.more-option-item .icon-cloud {
  margin-right: 8px;
  font-size: 16px;
}

.dropdown-triangle {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  margin-bottom: 5px;
  vertical-align: middle;
  border-top: 6px solid currentColor;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}
`, "",{"version":3,"sources":["webpack://./src/components/importLocal/importLocal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,oCAAoC,EAAE,mCAAmC;EACzE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;AACpC","sourcesContent":[".import-from-local {\n  position: fixed;\n  right: 0px;\n  top: 0px;\n  width: 138px;\n  margin-right: 25px;\n  margin-top: 23px;\n  min-width: 42px;\n  height: 42px;\n  opacity: 1;\n  border-radius: 25px;\n  line-height: 42px;\n  text-align: center;\n  cursor: pointer;\n  z-index: 5;\n  font-size: 15px;\n  transition: 0.1s;\n  font-weight: 500;\n}\n\n.import-book-box {\n  position: relative;\n  bottom: 42px;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  z-index: 10;\n  opacity: 0;\n  cursor: pointer;\n  font-size: 0;\n}\n.drag-section {\n  position: absolute;\n  top: 75px;\n  width: calc(100% - 200px);\n  height: calc(100vh - 90px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 5;\n}\n.more-import-option {\n  position: absolute;\n  width: 30px;\n  right: 0px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  z-index: 11;\n  background-color: rgba(0, 0, 0, 0.1); /* Semi-transparent white overlay */\n  border-radius: 0 30px 30px 0;\n}\n\n.icon-more {\n  font-size: 20px;\n}\n\n.more-options-dropdown {\n  position: absolute;\n  right: 0;\n  top: 100%;\n  border-radius: 10px;\n  width: 200px;\n  z-index: 999;\n  margin-top: 5px;\n  overflow: hidden;\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n\n.more-option-item {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-left: 20px;\n  transition: 0.2s;\n  line-height: 1;\n  height: 40px;\n  cursor: pointer;\n  text-align: left;\n}\n\n.more-option-item .icon-cloud {\n  margin-right: 8px;\n  font-size: 16px;\n}\n\n.dropdown-triangle {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  margin-bottom: 5px;\n  vertical-align: middle;\n  border-top: 6px solid currentColor;\n  border-right: 4px solid transparent;\n  border-left: 4px solid transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
